export const ToggleList3 = {
  data() {
    return {
      show: false
    }
  },
  methods: {
    display(){
      this.show = !this.show;
    }
  }
}